
export const getProductVariants = state => {
  return state.productVariants.data
}

export const getCurrentProduct = state => {
  return state.currentProduct
}

export const getCategories = state => {
  return state.categories
}

export const getIsRMP = state => {
  return state.isRMP
}

export const getProductList = state => {
  return state.productList
}

export const getAttributeObject = state => {
  return state.attributes
}

export const getAddNewProductList = state => {
  return state.addNewProductList
}

export const getGrandTotal = state => {
  return state.orders.grandTotal
}

export const getInputAddress = state => {
  return state.input
}

export const getCurrentProductVariants = state => {
  return state.currentProductVariants
}

export const getNewProductRemoveList = state => {
  return state.newProductRemoveList
}



// WEBPACK FOOTER //
// ./src/store/getters.js